export enum PortalStructureType {
  ATTACHED = 'Attached',
  DETACHED = 'Detached'
}
